import { createAction } from "redux-actions";
export const receiveIndicators = createAction("DATA/RECEIVE_INDICATORS");
export const receiveInitialIndicators = createAction("INITIAL/RECEIVE_INDICATORS");
